<h2 mat-dialog-title>{{ data.title || "Uwaga! Import możliwy tylko z plików w formacie xlsx" }}</h2>
<div mat-dialog-content>
    <p>{{ data.warningText || "Format poszczególnych kolumn musi być identyczny jak ten w szablonie."}}</p>
    <p style="padding-top:20px;padding-bottom:20px;" *ngIf="data.useTemplate">
        Wzór pliku do importu (
        <span
            (click)="downloadTemplate('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
            style="color:blue; cursor: pointer;"
        >
            Pobierz
        </span>
        )
    </p>
    <h4 style="padding-top:20px;padding-bottom:20px;">Plik do importu:</h4>
    <input type="file" id="file" (change)="fileChangeEvent($event.target.files)">
    <p *ngIf="!isHeadersValid" style="color:red;">Importowany plik nie jest zgodny z szablonem importu</p>
    <p *ngIf="!isFileValid" style="color:red;">Plik posiada nie wspierane rozszerzenie</p>
</div>
<div mat-dialog-actions fxLayout="row">
    <button-spinner class="ml-xxs" [inProgress]="uploading">
        <button mat-button (click)="onNoClick()">Zamknij</button>
        <button mat-button (click)="upload()" [disabled]="!canImport">Importuj</button>
    </button-spinner>
</div>
